import { CircularProgress } from "@mui/material"
import { pdf } from "@react-pdf/renderer"
import React, { Suspense, lazy, useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'

// Solo se descarga en los navegadores que lo necesitan
const VisorPDFMovil = lazy(() => import("./VisorPDFMovil"));

// Chrome en Android no tiene visor de PDF: dentro de un iframe solo ofrece descargarlo.
// Los navegadores lo indican con navigator.pdfViewerEnabled; si no lo dicen, se mira si es Android
const sinVisorIntegrado = () =>
    navigator.pdfViewerEnabled === false ||
    (navigator.pdfViewerEnabled === undefined && /Android/i.test(navigator.userAgent));

const PDFHandler = ({children: pdfContent, fileName: customFileName}) => {
    const { t } = useTranslation('common');
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    // Si pdf.js no puede con el documento se vuelve al iframe de siempre
    const [usarVisorPropio, setUsarVisorPropio] = useState(sinVisorIntegrado);

    const getFileNameFromUrl = () => {
        if (customFileName) {
            return customFileName.toLowerCase().endsWith('.pdf') ? customFileName : `${customFileName}.pdf`;
        }
        try {
            const url = new URL(window.location.href);
            const parts = url.pathname.split('/').filter(Boolean); // quita los vacíos
            const [docType, __, id, _] = parts.reverse(); // obtiene los 2 últimos segmentos
            console.log(parts)
            return `${docType}-${id}.pdf`;
        } catch {
            return 'documento.pdf';
        }
    };

    const loadPDF = async () => {
        try {
            const blob = await pdf(pdfContent).toBlob();
            
            // Crear un nuevo blob con el tipo correcto y agregar el nombre
            const namedBlob = new Blob([blob], { type: 'application/pdf' });
            const url = URL.createObjectURL(namedBlob);
            const fileName = getFileNameFromUrl();
            // Agregar el nombre del archivo al fragmento de la URL
            const urlWithName = `${url}#filename=${encodeURIComponent(fileName || 'documento.pdf')}`;
            
            setPdfUrl(urlWithName);
            setLoading(false);
        } catch (err) {
            console.error("Error generando PDF:", err);
            setLoading(false);
        }
    };
    
    useEffect(() => {
        loadPDF();
        // Cleanup: liberar la URL cuando el componente se desmonte
        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl.split('#')[0]);
            }
        };
    }, []);

    const handleDownload = () => {
        const fileName = getFileNameFromUrl();
        const link = document.createElement('a');
        link.href = pdfUrl.split('#')[0]; // Usa la URL sin el fragmento
        link.download = fileName || 'documento.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (loading) {
        return <CircularProgress style={{color:'#92004D', position: 'absolute', top: '50%', left: '50%'}} />;
    }

    try {
        // Intentar mostrar el PDF en un iframe, o con pdf.js si el navegador no sabe
        return (
            <div>
                {usarVisorPropio ? (
                    <Suspense fallback={<CircularProgress style={{color:'#92004D', position: 'absolute', top: '50%', left: '50%'}} />}>
                        <VisorPDFMovil url={pdfUrl.split('#')[0]} onError={() => setUsarVisorPropio(false)} />
                    </Suspense>
                ) : (
                    <iframe
                        src={pdfUrl}
                        style={{width: '100%', height: '100vh'}}
                    />
                )}
                <button 
                    onClick={handleDownload}
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        padding: '10px 20px',
                        backgroundColor: '#92004D',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    {t('actions.downloadPdf')}
                </button>
            </div>
        );
    } catch (err) {
        return null;
    }
};

export default PDFHandler;